import { div } from "framer-motion/client";
import React from "react";

const CustomTag = ({
  count = "65",
  icon = "",
  description = "description",
  size = "xs",
  color = "primary",
  variant = "contained",
  className = "",
}) => {
  const sizeStyles = {
    xs: " p-1",
    "xs-sm": " p-1",
    sm: " px-3 py-1.5",
    md: " px-3 py-1.5",
    lg: " px-4 py-2",
    xl: " px-4 py-2",
  };

  const iconSizeStyles = {
    xs: "text-[12px] ",
    "xs-sm": "text-[12px]",
    sm: "text-[14px] leading-4 ",
    md: "text-[16px]",
    lg: "text-[20px]",
    xl: "text-[22px]",
  };

  const countSizeStyles = {
    xs: "text-[20px] font-semibold ml-4",
    "xs-sm": "text-[24px] font-semibold ml-4",
    sm: "text-[28px] font-semibold leading-[34px] ml-4",
    md: "text-[30px] font-semibold ml-4",
    lg: "text-[32px] font-semibold ml-4",
    xl: "text-[34px] font-semibold ml-4",
  };

  const descriptionSizeStyles = {
    xs: "text-[8px]",
    "xs-sm": "text-[10px] ",
    sm: "text-[12px] ",
    md: "text-[14px] ",
    lg: "text-[16px] ",
    xl: "text-[18px] ",
  };

  const colors = {
    primary: {
      contained: "bg-primary-100 text-primary ",
      outlined: "border border-primary text-primary",
      text: "text-primary",
    },
    warning: {
      contained: "bg-warning-50 text-warning ",
      outlined: "border border-warning-100 text-warning",
      text: "text-warning",
    },
    success: {
      contained: "bg-success-50 text-success ",
      outlined: "border border-success-100 text-success",
      text: "text-success",
    },
    danger: {
      contained: "bg-danger-50 text-danger",
      outlined: "border border-danger-100 text-danger",
      text: "text-danger",
    },
    info: {
      contained: "bg-info-50 text-black font-semibold",
      outlined: "border border-info-100 text-info",
      text: "text-info",
    },
    black: {
      contained: "bg-black-50 text-black ",
      outlined: "border border-black text-black",
      text: "text-black",
    },
    white: {
      contained: "bg-neutrals-50 text-black border border-neutrals-50",
      outlined: "border border-gray-300 text-gray-700",
      text: "text-gray-700",
    },
  };

  return (
    <div className="inline-block">
      <div
        className={` body-two rounded flex justify-center items-center  ${sizeStyles[size]} ${colors[color]?.[variant]} ${className}`}
      >
        <div className="flex items-center justify-between ">
          <div>
            {icon && (
              <span
                className={`material-symbols-rounded  ${iconSizeStyles[size]} ${colors[color]?.[variant]}`}
              >
                {icon}
              </span>
            )}
            {/* {description && (
            <div className={`${descriptionSizeStyles[size]}`}>
              {description}
            </div>
          )} */}

            <div className={`${descriptionSizeStyles[size]}`}>
              {description}
            </div>
          </div>

          <div className={`${countSizeStyles[size]}`}>{count}</div>
        </div>
      </div>
    </div>
  );
};

export default CustomTag;
